import { z } from 'zod';
import { parseFiniteNumber } from '../../parse-finite-number.js';
import { PURCHASE_ORDER_CONSTRAINTS } from './constraints.js';
// Upper bound stays well under the Decimal(28,9) column's overflow point.
const MAX_PURCHASE_ORDER_QUANTITY = 1_000_000_000;
const MAX_QUANTITY_TEXT = MAX_PURCHASE_ORDER_QUANTITY.toLocaleString('en-US');
/** The one wording for "this quantity is unusable", so a bound change can't leave a caller's copy stale. */
export const PURCHASE_ORDER_QUANTITY_MESSAGE = `${PURCHASE_ORDER_CONSTRAINTS.quantity.label} must be a valid number greater than 0 and ${MAX_QUANTITY_TEXT} or less.`;
export const purchaseOrderQuantitySchema = z
    .number()
    .positive(`${PURCHASE_ORDER_CONSTRAINTS.quantity.label} must be greater than 0.`)
    .max(MAX_PURCHASE_ORDER_QUANTITY, `${PURCHASE_ORDER_CONSTRAINTS.quantity.label} must be ${MAX_QUANTITY_TEXT} or less.`);
export function parsePurchaseOrderQuantity(value) {
    const parsed = parseFiniteNumber(value);
    return parsed !== undefined && purchaseOrderQuantitySchema.safeParse(parsed).success
        ? parsed
        : undefined;
}
//# sourceMappingURL=item-quantity.js.map